const PORTAL_HOSTNAME = 'portal.botpros.ai'
const OPS_HOSTNAME = 'ops.botpros.ai'
const PORTAL_HASH_PATTERN = /^#\/portal(?:\/|$)/

export function isPortalBootRoute(hostname: string, hash: string): boolean {
  return hostname === PORTAL_HOSTNAME || PORTAL_HASH_PATTERN.test(hash)
}

export function resolvePortalHostHash(hostname: string, hash: string): string | null {
  if (hostname !== PORTAL_HOSTNAME || PORTAL_HASH_PATTERN.test(hash)) return null
  return '#/portal/login'
}

export function resolveCrossHostPortalRedirect(hostname: string, hash: string): string | null {
  if (hostname !== OPS_HOSTNAME || !PORTAL_HASH_PATTERN.test(hash)) return null
  return 'https://portal.botpros.ai/' + hash
}
